import { Search } from 'lucide-react';
import React from 'react';

interface AutocompleteSearchProps {
  id: string;
  searchPlaceholder: string;
  search: string;
  onSearch: (value: string) => void;
}
const AutocompleteSearch = ({ id, searchPlaceholder = 'Search...', search, onSearch }: AutocompleteSearchProps) => {
  return (
    <div className="relative w-full">
      <Search className="w-[16px] h-[16px] absolute left-[10px] top-1/2 -translate-y-1/2 stroke-[#9D9D9C]" />
      <input
        id={`search-${id}`}
        type="text"
        className="h-[38px] w-full pl-[30px] text-[#4B4B4B] text-[14px] border border-[#D9D9D9] rounded-[8px] focus:border-[#0C8DBF] outline-none"
        placeholder={searchPlaceholder}
        value={search}
        onChange={(e) => {
          const val = e.target.value;
          onSearch(val);
        }}
        autoFocus
      />
    </div>
  );
};

export default AutocompleteSearch;
